import React from 'react';
import * as Sentry from '@sentry/nextjs';
import { ENVIRONMENT } from '@const/index';
import styles from '@components/errors/ErrorBoundary.styles';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
type PropsType = {
  children: React.ReactNode;
  errorMessage?: React.ReactNode;
};
const ErrorBoundary = ({
  children,
  errorMessage = 'Error occurred'
}: PropsType) => {
  const fallback = ({
    componentStack
  }) => {
    if (ENVIRONMENT === 'production') {
      return <div />;
    }
    console.log(componentStack);
    return <div sx={styles.errorMessage}>
        <Heading h={3} color={theme.rawColors.accent700}>
          {errorMessage}
        </Heading>
      </div>;
  };
  return <Sentry.ErrorBoundary fallback={fallback}>{children}</Sentry.ErrorBoundary>;
};
export default ErrorBoundary;